<template>
  <ul class="kt-menu__nav">
    <template v-for="(menu, i) in menuItems">
      <KTMenuItem v-if="!menu.section" :menu="menu" :key="i"></KTMenuItem>
      <KTMenuSection v-if="menu.section" :menu="menu" :key="i"></KTMenuSection>
    </template>
  </ul>
</template>

<script>
import KTMenuItem from "@/views/theme/aside/MenuItem.vue";
import KTMenuSection from "@/views/theme/aside/MenuSection.vue";
import { GET_GROUPS } from "@/store/auth.module";
import { VERIFY_FEATURE_ARRAY } from "@/store/feature.module";

export default {
  name: "KTAsideMenu",
  data: () => {
    return { menuItems: [] };
  },
  components: {
    KTMenuItem,
    KTMenuSection
  },
  computed: {
    adminGroupName() {
      return "Admin";
    },
    merchantAdminGroupName() {
      return "MerchantAdmin";
    }
  },
  methods: {
    async updateFeaturesArray() {
      await this.$store.dispatch(VERIFY_FEATURE_ARRAY);
    },
    checkIfFeatureIsEnabled(featureName) {
      return !featureName || this.$store.getters.verifyFeature(featureName);
    },
    loadAdminGroup(groups) {
      if (!groups.includes(this.adminGroupName)) return [];

      return require(`@/common/config/menu.${this.adminGroupName.toLowerCase()}.config.json`).aside.items.filter(
        i => this.checkIfFeatureIsEnabled(i.featureName)
      );
    },
    loadMerchantAdminGroup(groups) {
      if (!groups.includes(this.merchantAdminGroupName)) return [];

      return require(`@/common/config/menu.${this.merchantAdminGroupName.toLowerCase()}.config.json`).aside.items.filter(
        i => this.checkIfFeatureIsEnabled(i.featureName)
      );
    },
    loadMerchantUserGroup(groups) {
      if (
        groups.includes(this.adminGroupName) ||
        groups.includes(this.merchantAdminGroupName)
      )
        return [];

      return require(`@/common/config/menu.merchantuser.config.json`).aside.items.filter(
        i => {
          return (
            this.checkIfFeatureIsEnabled(i.featureName) &&
            this.$role.verify(i.groups)
          );
        }
      );
    }
  },
  async mounted() {
    const vm = this;
    await this.updateFeaturesArray();
    const groups = await this.$store.dispatch(GET_GROUPS);
    this.menuItems = this.menuItems.concat([
      ...this.loadAdminGroup(groups),
      ...this.loadMerchantAdminGroup(groups),
      ...this.loadMerchantUserGroup(groups)
    ]);
  }
};
</script>
